import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa'; // Import profile icon
import Notifications from './Pages/Notifications';
import './MainNavbar.css';
import '../Matrimony/Pages/Notifications.css';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import socket from '../../utils/socket';
import { useContext } from "react";
import AlertContext from "../../contexts/AlertContext";

function MainNavbar() {
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [showAlertBox, setShowAlertBox] = useState(false);
    const [notificationContent, setNotificationContent] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();
    const { userId } = useParams(); // Access userId from route params
    const [basicDetails, setBasicDetails] = useState({});
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const location = useLocation();
    const currentPath = location.pathname;
    const [notificationCount, setNotificationCount] = useState(0);
    const { showAlert } = useContext(AlertContext);
    const handleNavigate = (path) => {
        navigate(path);
        window.scrollTo(0, 0);
        setIsNavOpen(false);
    };
    const [showNavi, setShowNavi] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const showNav = ["/profile", "/preference", "/subscription", "/userpaymenthistory", "/inbox", "/ai", "/ai/compatibility", "/ai/chat", "/ai/match"].includes(currentPath);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY) {
                // scrolling down → hide
                setShowNavi(false);
            } else {
                // scrolling up → show
                setShowNavi(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY]);


    // ✅ Check login status on load
    useEffect(() => {
        const token = localStorage.getItem('token');
        setIsLoggedIn(!!token);
    }, []);


    const toggleNavbar = () => {
        setIsNavOpen(!isNavOpen);
    };

    const handleNotificationClick = () => {
        setNotificationContent(<Notifications />);
        setShowAlertBox(true);
    };

    const handleCloseAlertBox = () => {
        setShowAlertBox(false);
    };

    // Add this useEffect to fetch unread notification count
    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        const userId = storedUser?._id;
        if (!userId) return;

        const fetchUnreadNotifications = async () => {
            try {
                const { data } = await axios.get(
                    `https://back.varankal.com/notifications/unread-count?userId=${userId}`,
                    {
                        withCredentials: true,
                        headers: { 'Cache-Control': 'no-cache' }
                    }
                );
                setNotificationCount(data.unreadCount);
            } catch (err) {
                console.error("Failed to fetch notification count:", err);
            }
        };

        fetchUnreadNotifications();
        const interval = setInterval(fetchUnreadNotifications, 5000); // fetch every 5s
        return () => clearInterval(interval);
    }, []);

    const markNotificationsAsRead = async () => {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        const userId = storedUser?._id;
        if (!userId) return;

        try {
            await axios.put(
                'https://back.varankal.com/notifications/mark-all-read',
                {},
                { withCredentials: true }
            );
            setNotificationCount(0); // Reset the badge immediately
        } catch (err) {
            console.error('Failed to mark notifications as read:', err);
        }
    };

    // const handleSettingsClick = () => {
    //     if (!isLoggedIn) {
    //         navigate('/');
    //         showAlert('⚠ Please login first to access Settings.');
    //     } else {
    //         // Only toggle dropdown on mobile
    //         if (window.innerWidth <= 480) {
    //             setIsDropdownOpen((prev) => !prev);
    //         }
    //     }
    // };


    // ✅ Handle Profiles Menu Click (If Not Logged In)
    const handleProfilesClick = () => {
        window.scrollTo(0, 0); // Scroll to top on click
        if (!isLoggedIn) {
            navigate('/');
            showAlert('Please login first to access Profiles.', "error");
        } else {
            navigate('/homelist'); // Navigate to the profiles page if logged in
        }
    };

    const handleMatchesClick = () => {
        window.scrollTo(0, 0);

        if (!isLoggedIn) {
            navigate('/');
            showAlert("Please login first to access Matches", "error");
        } else {
            navigate('/matchlist');
        }
    };


    useEffect(() => {
        const fetchBasicDetails = async () => {
            try {
                const response = await axios.get(`https://back.varankal.com/user/currentregister-details/${userId}`, { withCredentials: true });
                setBasicDetails(response.data.basicDetails);
            } catch (error) {
                console.error('Error fetching user data', error);
            }
        };

        // Call functions to fetch data
        fetchBasicDetails();

    }, [userId]); // Include userId in dependency array to fetch data when it changes

    const handleLogout = async () => {
        try {
            const response = await axios.post(
                'https://back.varankal.com/auth/logout',
                {},
                { withCredentials: true }
            );

            if (response.status === 200) {
                console.log(response.data.message); // Logout successful

                // ✅ Update state first
                setIsLoggedIn(false);

                // ✅ Disconnect socket
                if (socket && socket.connected) {
                    socket.disconnect();
                    console.log('🔌 Socket disconnected');
                }

                // ✅ Clear local storage
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('profileCreated');

                // ✅ Then redirect
                navigate('/');
            } else {
                console.error('Logout failed.');
            }
        } catch (error) {
            console.error('Logout error:', error.response?.data?.message || error.message);
        }
    };


    return (
        <>
            {showAlertBox && (
                <div className={`alert-box ${!showAlertBox ? 'hide' : ''}`}>
                    <div className="alert-content">
                        {notificationContent}
                    </div>
                    <button className="close-alert" onClick={handleCloseAlertBox}>×</button>
                </div>
            )}
            <nav className={`mainnavbar ${showNavi ? "nav-show" : "nav-hide"}`}>
                <div className="container3">
                    <div
                        className="mainnavbar-brand"
                        onClick={() => handleNavigate('/aboutus')}
                    >
                        <img
                            src="/Images/icon tm.png"
                            alt="Varankal Logo"
                            className="navbar-logo"
                        />
                    </div>

                    <div className="mainnavbar-toggle" onClick={toggleNavbar}>
                        {isNavOpen ? "✕" : "☰"}
                    </div>

                    <div className={`mainnavbar-collapse ${isNavOpen ? 'show' : ''}`} id="basic-navbar-nav">
                        <ul className="mainnav">
                            {/* <li className="mainnav-item"><a onClick={() => { handleNavigate('/homepage'); window.scrollTo(0, 0); }}>Varankal</a></li> */}
                            <li className="mainnav-item"><a onClick={() => { handleNavigate('/aboutus'); window.scrollTo(0, 0); }}>About</a></li>
                            <li className="mainnav-item"><a onClick={handleProfilesClick}>Matching Score</a></li>
                            <li className="mainnav-item"><a onClick={handleMatchesClick}>Profile Matches</a></li>
                            {/* <li className="mainnav-item"><a onClick={() => { handleNavigate('/astrology'); window.scrollTo(0, 0); }}>Astrologers</a></li> */}
                            <li className="mainnav-item"><a onClick={() => { handleNavigate('/contactus'); window.scrollTo(0, 0); }}>Help</a></li>
                        </ul>

                        {showNav && (
                            <div className="dropdown-menu-horizontal">
                                <a
                                    className={currentPath === "/profile" ? "active" : ""}
                                    onClick={() => handleNavigate("/profile")}
                                >
                                    My Profile
                                </a>

                                <a
                                    className={currentPath === "/inbox" ? "active" : ""}
                                    onClick={() => {
                                        handleNavigate("/inbox");
                                        markNotificationsAsRead();
                                    }}
                                >
                                    Inbox
                                    {notificationCount > 0 && (
                                        <span className="notification-badge">{notificationCount}</span>
                                    )}
                                </a>
                                {/* 🔥 AI MENU – SAME STYLE */}
                                <div className="nav-link-with-submenu">
                                    <a className="nav-link">AI Features</a>

                                    <div className="submenu">
                                        <a onClick={() => handleNavigate("/ai")}>AI Profile</a>
                                        <a onClick={() => handleNavigate("/ai/chat")}>AI Chat</a>
                                        <a onClick={() => handleNavigate("/ai/match")}>AI Match</a>
                                        <a onClick={() => handleNavigate("/ai/compatibility")}>
                                            AI Compatibility
                                        </a>
                                    </div>
                                </div>
                                <a
                                    className={currentPath === "/subscription" ? "active" : ""}
                                    onClick={() => handleNavigate("/subscription")}
                                >
                                    Upgrade
                                </a>

                                <a
                                    className={currentPath === "/userpaymenthistory" ? "active" : ""}
                                    onClick={() => handleNavigate("/userpaymenthistory")}
                                >
                                    Payments
                                </a>


                            </div>
                        )}



                        <div className="nav-right">
                            {localStorage.getItem('token') ? (
                                <>
                                    <div
                                        className="user-avatar-container"
                                        onClick={() => {
                                            navigate("/profile?showNav=true");
                                            window.scrollTo(0, 0);
                                        }}
                                    >
                                        {basicDetails.profilePicture ? (
                                            <img
                                                src={`data:image/jpeg;base64,${basicDetails.profilePicture}`}
                                                alt="User Avatar"
                                                className="user-avatar-image"
                                            />
                                        ) : (
                                            <div className="user-avatar-placeholder">No Profile Picture</div>
                                        )}
                                    </div>

                                    <a className="logout-link" onClick={handleLogout}>Logout</a>
                                </>
                            ) : (
                                <a className="logout-link" onClick={() => { handleNavigate('/'); window.scrollTo(0, 0); }}>Varankal</a>
                            )}
                        </div>
                    </div>
                </div>
            </nav>

            {showSearchBar && (
                <div className="search-bar">
                    <input type="text" placeholder="Search..." />
                    <button>Search</button>
                </div>
            )}
        </>
    );
}

export default MainNavbar;
